import { TranslationDictionary } from '@plandi/common'
import * as Yup from 'yup'

export const changeEmailValidationSchema = (
  translate: TranslationDictionary['data']
) => {
  return Yup.object().shape({
    email: Yup.string()
      .email(translate?.['wrong-email'] ?? 'Неправильный email')
      .required(translate?.['required-field'] ?? 'Обязательное поле'),
    currentPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий')
  })
}

export const changePhoneNumber = (translate: TranslationDictionary['data']) =>
  Yup.object().shape({
    name: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(2, translate?.['short-name'] ?? 'Слишком короткое имя!')
      .max(100, translate?.['too-long'] ?? 'Слишком длинное имя!'),
    phone: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .matches(
        /[0-9]+$/,
        translate?.['phone-number-contain-10-digits'] ??
          'Номер телефона должен содержать код и 10 цифр'
      )
  })

export const changePasswordValidationSchema = (
  translate: TranslationDictionary['data'],
  locale: string
) =>
  Yup.object().shape({
    newPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий'),
    currentPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий'),
    confirmPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий')
      .oneOf(
        [Yup.ref('newPassword'), null],
        locale === 'ru' ? 'Пароли не совпадают' : 'Passwords do not match'
      )
  })
